module.exports = require("@uppy/core");